import {TFunction} from 'i18next';
import {Resource, ResourceGroups} from './types';
import {MarkerData} from '../../../../../submodules/map/mapiq-map/markers/NodeMarkerData';

export const transformResourcesToResourcesGroups = (t: TFunction, data: Resource[]) =>
  data.reduce<Partial<ResourceGroups>>(
    (a, c) => {
      if (c.type === 'facility' && c.data.facilityType) {
        const subType = c.data.facilityType.id;
        if (!a[subType]) {
          a[subType] = {
            type: c.type,
            //@ts-ignore
            displayName: t(`facilities:facilityType_${subType}`),
            iconUrl: c.data.facilityType.lightIconUrl,
          };
        }
      }

      return a;
    },
    {
      Workspaces: {
        type: 'area',
        displayName: t('hereAndNow:ResourceFilterAreas'),
      },
      MeetingRooms: {
        type: 'room',
        displayName: t('hereAndNow:ResourceFilterRooms'),
      },
    },
  );

export const resourceGroupOrder: (keyof ResourceGroups)[] = [
  'Workspaces',
  'MeetingRooms',
  'FoodAndDrinks',
  'Lounge',
  'Toilet',
  'AccessibleToilet',
  'Reception',
  'Lockers',
  'PrintArea',
  'Storage',
  'Elevator',
  'Stairs',
  'Wardrobe',
  'Other',
];

export const getMarkerPriorities = (
  allResources: Resource[],
  highlightedNodeIds: string[],
  activeTypeFilters: string[],
) => {
  const FILTER_PRIO = 3;
  const HIGH_PRIO = 4;

  const getFilterPrio = (type: MarkerData['type']) => (activeTypeFilters.includes(type) ? FILTER_PRIO : undefined);

  const highlightedPriority = highlightedNodeIds.reduce(
    (acc, curr) => ({...acc, [curr]: HIGH_PRIO}),
    {} as {[key: string]: number | undefined},
  );

  return allResources.reduce(
    (acc, {id, type}) => ({...acc, [id]: highlightedPriority[id] ?? getFilterPrio(type)}),
    {} as {[key: string]: number | undefined},
  );
};
